import http from '@/utils/http'

const cartsApi = {
  // 获取购物车列表
  getCartsList(data: any) {
    return http.post<any>('/business/shopCart/getResourceCartList', data)
  },
  
  // 删除购物车
  delCartsItem(data: any) {
    return http.post<any>('/business/shopCart/deleteResourceCart', data)
  }

}
export default cartsApi